
import React from "react";
import { Row, Col, Skeleton } from "antd";
import { VaultFolder } from "@/types";
import FolderCard from "./FolderCard";

interface FolderGridProps {
  folders: VaultFolder[];
  isLoading?: boolean;
  selectedIds: Set<string>;
  onFolderClick: (folder: VaultFolder, e: React.MouseEvent) => void;
  onFolderDoubleClick: (folder: VaultFolder) => void;
  onFolderContextMenu: (folder: VaultFolder, e: React.MouseEvent) => void;
  onFolderShare?: (folder: VaultFolder) => void;
  onFolderRename?: (folder: VaultFolder) => void;
  onFolderDelete?: (folder: VaultFolder) => void;
  canShare?: boolean;
}

export default function FolderGrid({
  folders,
  isLoading = false,
  selectedIds,
  onFolderClick,
  onFolderDoubleClick,
  onFolderContextMenu,
  onFolderShare,
  onFolderRename,
  onFolderDelete,
  canShare = true,
}: FolderGridProps) {
  if (isLoading) {
    return (
      <div style={{ marginBottom: 24 }}>
        <div className="section-label">FOLDERS</div>
        <Row gutter={[16, 16]}>
          {[1, 2, 3, 4].map((i) => (
            <Col key={i} xs={12} sm={8} md={6} lg={6}>
              <Skeleton.Node active style={{ width: "100%", height: 80 }} />
            </Col>
          ))}
        </Row>
      </div>
    );
  }

  if (folders.length === 0) {
    return null;
  }

  return (
    <div style={{ marginBottom: 24 }}>
      <div className="section-label">FOLDERS</div>
      <Row gutter={[16, 16]}>
        {folders.map((folder) => (
          <Col key={folder.id} xs={12} sm={8} md={6} lg={6}>
            <FolderCard
              folder={folder}
              isSelected={selectedIds.has(folder.id)}
              onClick={(e) => onFolderClick(folder, e)}
              onDoubleClick={() => onFolderDoubleClick(folder)}
              onContextMenu={(e) => onFolderContextMenu(folder, e)}
              onShare={() => onFolderShare?.(folder)}
              onRename={() => onFolderRename?.(folder)}
              onDelete={() => onFolderDelete?.(folder)}
              canShare={canShare}
            />
          </Col>
        ))}
      </Row>
    </div>
  );
}
